import React from "react";
import { BaseActivity } from "../../model/activity/BaseActivity";
import { AtiraCollapse } from "../AtiraCollapse";
import { Flex } from "../Flex";
import { useTranslation } from "react-i18next";
import { AtiraIcon } from "../AtiraIcon";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons/faArrowUp";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons/faArrowDown";
import { ActivityMetaMap } from "../../model/activity/types/ActivityMetaKeysMap";
import { RenderMetaNode } from "./components/RenderMetaNode";
import { getActivityDetailKeys } from "./utils/activityUtils";

type Props = {
  activity: BaseActivity;
};

export const ActivityTimelineCollapse: React.FC<Props> = ({ activity }) => {
  const { t } = useTranslation();
  const detailKeys = getActivityDetailKeys(activity);

  if (!detailKeys.length) {
    return null;
  }

  return (
    <AtiraCollapse
      items={[
        {
          key: activity?._id,
          label: t("common.viewDetails"),
          children: detailKeys.map((key, i) => (
            <Flex key={`${key}-${i}`}>
              <RenderMetaNode
                mapKey={key as keyof ActivityMetaMap}
                node={activity.meta?.[key as keyof ActivityMetaMap]}
                activity={activity}
              />
            </Flex>
          )),
        },
      ]}
      expandIcon={({ isActive }) =>
        isActive ? (
          <AtiraIcon cursor="pointer" icon={faArrowUp} color="main" size="xl" />
        ) : (
          <AtiraIcon
            cursor="pointer"
            icon={faArrowDown}
            color="main"
            size="xl"
          />
        )
      }
      size="small"
      bordered
    />
  );
};
